import Button from "@/components/common/Buttons/Button";
import {useCallback, useImperativeHandle, useState, forwardRef, useEffect} from "react";
import NewsletterModal from "@/components/ModalVariants/NewsletterModal";
import useGlobals from "@/hooks/useGlobals";
import {useRouter} from "next/router";

const NewsletterModalAction = forwardRef(({ showButton = true }, ref) => {
	const router = useRouter()
	const footer = useGlobals(state => state.footer)
	const buttonText = footer?.newsletter?.buttonText || ''

	const [modalOpen, setModalOpen] = useState(false)

	const handleModalOpen = useCallback(() => {
		setModalOpen(true);

		const query = new URLSearchParams(router.query);
		query.set('newsletter', '');

		const queryString = [...query.entries()]
			.map(([key, value]) => (value === '' ? key : `${key}=${value}`))
			.join('&');

		const finalUrl = `${router.pathname}?${queryString}`;
		router.push(finalUrl, undefined, { shallow: true });
	}, [router]);

	const handleModalClose = useCallback(() => {
		setModalOpen(false);

		const { newsletter, ...restQuery } = router.query;
		router.replace({
			pathname: router.pathname,
			query: restQuery
		}, undefined, { shallow: true });
	}, [router]);

	useImperativeHandle(ref, () => ({
		handleModalOpen
	}));

	useEffect(() => {
		if (router.isReady && router.query.newsletter === '') {
			handleModalOpen();
		}
	}, [router.isReady]);

	return <>
		<NewsletterModal isOpen={modalOpen} handleClose={handleModalClose} />
		{showButton && (
			<Button onClick={handleModalOpen}>{buttonText}</Button>
		)}
	</>
});

NewsletterModalAction.displayName = 'NewsletterModalAction';

export default NewsletterModalAction;